// extracted by mini-css-extract-plugin
export default {"notFound":"Notfound_notFound__qeJKT"};